export enum OrganizationOrigin {
    police = 'police', // cspell:ignore ajman
    injaz = 'injaz', // cspell:ignore injaz
    localhost = 'localhost',
    staging = 'dev.masar.pro',
    amiriGuard = '172.16.30.9',
    amiriGuard2 = 'aguard.gov.ae', // cspell:ignore aguard
    takamul = 'takamul', // cspell:ignore takamul
}
